import React from 'react';
import styled from 'styled-components';

import {newPalette, NewPaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/colorStyles';
import {ProgressBar} from '../../components/charts/components/progressBar/progressBar';
import {StyledFlex} from '../../components/reportViewer/reportCommons';
import {MetricNumericalRenderer} from '../analyticsFormatHelpers';
import {renderPercentageValue} from './percentMetricRenderer';

/*
 * Styles.
 */

const StyledProgressBarWrapper = styled.div`
  flex: 1;
`;

const StyledPercentValue = styled.div`
  width: 36px;
  margin-left: 7px;
`;

/*
 * Formatter.
 */

export const renderProgressValue: MetricNumericalRenderer = ({value, shouldRenderOnlyWholeNumbers}) => {
  const formattedVal = renderPercentageValue({value, shouldRenderOnlyWholeNumbers});

  const series = [
    {
      value: value * 100,
      color: newPalette[NewPaletteColorsEnum.BLUE].regular,
    },
  ];
  return (
    <StyledFlex>
      <StyledProgressBarWrapper>
        <ProgressBar height={12} series={series} />
      </StyledProgressBarWrapper>
      <StyledPercentValue>{formattedVal}</StyledPercentValue>
    </StyledFlex>
  );
};
